import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import lobbyReducers from "../reducers"

/* Leave the room on purpose (`POST /lobby/<n>/leave/`). Since gamekit 0.8.0 closing the lobby socket
   is only being away, so this is what the lobby's LEAVE calls (owner, 2026-10-19). The caller closes
   the socket first, so this phone is not told about its own leave. */
export const thunk = createAsyncThunk("lobby/leaveRoom", async (data, { rejectWithValue }) => {
  try {
    await apiClient.post(`/lobby/${data.lobbyNumber}/leave/`, null, { handlesOwnErrors: true })
    return data
  } catch (error) {
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = (state, action) => lobbyReducers.leaveLobby(state, { payload: action.payload })

const thunkObject = { thunk, onSucceed }
export default thunkObject
